import React from "react";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { useEffect, useState } from "react";
import { DateRangePicker } from "react-date-range";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Collapse from "@mui/material/Collapse";
import Paper from "@mui/material/Paper";
import { format } from "date-fns";

const DateRange = (props) => {
  const {
    inputlabel,
    handleFilter,
    currentrRange,
    btnlable,
    customStyle,
    pckrStyle,
    handlePickerOpen,
    openRange,
    btnlableClear,
    setOpenRange,
    setFilterRange,
    filterRange,
  } = props;
  const [state, setState] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);
  const [checked, setchecked] = useState(false);
  const handleApply = () => {
    setchecked(false);
    const startDate = format(state[0]["startDate"], "yyyy-MM-dd");
    const endDate = format(state[0]["endDate"], "yyyy-MM-dd");
    const newrange = { startDate: startDate, endDate: endDate };
    handleFilter(newrange);
  };

  useEffect(() => {
    setState(() => [
      {
        startDate: new Date(),
        endDate: new Date(),
        key: "selection",
      },
    ]);
    if (filterRange && filterRange.startDate) {
      const temp = { startDate: "", endDate: "", color: "" };
      temp.endDate = new Date(filterRange.endDate);
      temp.startDate = new Date(filterRange.startDate);
      temp.color = "#3d91ff";
      setState(() => [temp]);
    } else {
      setState(() => [
        {
          startDate: new Date(),
          endDate: new Date(),
          key: "selection",
        },
      ]);
    }
  }, [filterRange]);

  const handleClear = () => {
    const clearRange = {
      startDate: "",
      endDate: "",
    };
    setFilterRange(() => clearRange);
    setOpenRange(() => false);
  };

  const handleInputChange = (e) => {
    e.preventDefault();
  };
  const handleChange = (item) => {
    if (filterRange && filterRange.startDate) {
      const clearRange = {
        startDate: "",
        endDate: "",
      };
      setFilterRange(() => clearRange);
      setState(() => [item.range1]);
    } else {
      setState([item.selection]);
    }
  };
  const handleFocus = () => {
    setchecked(true);
  };

  return (
    <>
      {checked ? (
        <div
          className={StyledComponent.pckrOverlay}
          onClick={() => setchecked(false)}
        ></div>
      ) : (
        <></>
      )}
      <form
        className={StyledComponent.container}
        noValidate
        style={customStyle.frmStyle ? customStyle.frmStyle : ""}
      >
        <Grid item xs={12}>
          <Grid container></Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container className={pckrStyle ? StyledComponent.pckr : ""}>
            <Collapse in={openRange}>
              <Paper elevation={4}>
                <Grid item xs={12}>
                  <DateRangePicker
                    onChange={(item) => handleChange(item)}
                    showSelectionPreview={true}
                    moveRangeOnFirstSelection={true}
                    months={2}
                    ranges={state}
                    direction="horizontal"
                    editableDateInputs={false}
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  style={{
                    textAlign: "end",
                    paddingRight: "15px",
                    paddingBottom: "15px",
                  }}
                  className={StyledComponent.applybtn}
                >
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={handleClear}
                    className={StyledComponent.saveButton}
                  >
                    {btnlableClear}
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleApply}
                    style={{ marginLeft: "10px", color: "white" }}
                    className={StyledComponent.saveButton}
                  >
                    {btnlable}
                  </Button>
                </Grid>
              </Paper>
            </Collapse>
          </Grid>
        </Grid>
      </form>
    </>
  );
};

const StyledComponent = styled(DateRange)(({ theme }) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  input: {
    padding: "4px",
    width: "200px",
    background: "#F1F1F1",
  },
  positionEnd: {
    padding: "2px",
    display: "none",
  },
  positionStart: {
    display: "none",
  },
  subtitle: {
    color: "#33a0ff",
    fontWeight: 600,
  },
  pckr: {
    position: "absolute",
    width: "890px",
    background: "red",
    top: "34px",
    right: "0px",
    zIndex: theme.zIndex.modal,
  },
  applybtn: {
    background: "#FFFFFF",
    padding: "1px 20px",
  },
  saveButton: {
    display: "flex",
    margin: "5px",
    borderRadius: "5px",
    boxShadow: "0 0 0 0 rgba(0, 0, 0, 0.16)",
    border: "solid 1px #ff867a",
    backgroundColor: "#ff867a",
    fontSize: "16px",
    fontWeight: "bold",
    color: "#ffffff",
    width: "130px",
    "&:hover": {
      backgroundColor: "#dc7a70",
    },
  },
  pckrOverlay: {
    width: "100%",
    height: "100%",
    position: "absolute",
    left: "0px",
    top: "0px",
    zIndex: theme.zIndex.modal - 1,
  },
}));

export default DateRange;
